import React from 'react';
import { DatoCmsBrandLogoSectionComponent } from '../../../schema/datocms';
import { getColumnSpanClass, getColumnStartClass} from '../../../utilities';
import BrandLogoComponent from '../../block-components/brand-logo-component/brand-logo-component';
import HtmlStringComponent from '../../html-string/html-string-component';
import { useThemeClassMap } from '../../theme/useThemeClassMap';

const BrandLogoSectionComponent = ({ descriptionHtml, theme, columnLayout, brandLogos }: DatoCmsBrandLogoSectionComponent): React.ReactElement => {
    const themeClass = useThemeClassMap(theme);
    const gridColumnSpanClass: string = getColumnSpanClass(columnLayout);
    const gridColumnStartClass: string = getColumnStartClass(columnLayout);

    return (
        <div className={`hidden lg:block ${ themeClass } bg-theme-primary py-12`}>
            <div className="container mx-auto lg:grid lg:grid-cols-12">
                <div className={`lg:${gridColumnSpanClass} lg:${gridColumnStartClass}`}>
                    <div className="flex items-center justify-between">
                        { descriptionHtml && <HtmlStringComponent htmlString={descriptionHtml} skipAlignmentClasses={true} /> }

                        {
                            brandLogos?.map((block, index) => {
                                return <BrandLogoComponent key={index} {...block} />;
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BrandLogoSectionComponent;
